$(".contact-us-block-form").submit(function (e) {
    e.preventDefault();

    var $this_form = $(this);
    var data = $this_form.serialize();
    var $success_message = $this_form.find(".success_message");
    var $error_message = $this_form.find(".error_message");
    var $form_item = $this_form.find(".form-item");

    $this_form.find(".error").removeClass("error");
    $success_message.fadeOut(0);
    $error_message.fadeOut(0);

    if(
        $('input[name="name"]').val()
        && $('input[name="email"]').val()
        && $('select[name="type_of_message"]').val()
    ){
        $this_form.addClass('loading');
    }

    $.post($('input[name="ajax_url"]').val(), data, function (response) {

        try {
            if (response.success === true) {
                $('input[name="name"]').val('');
                $('input[name="name"]').attr('value','');
                $('input[name="email"]').val('');
                $('input[name="email"]').attr('value','');
                $('textarea[name="message"]').val('');
                $('textarea[name="message"]').attr('value','');

                $this_form.find(".error").removeClass("error");

                $form_item.fadeOut(0);
                $success_message.fadeIn(0);

                try {
                    dataLayer.push({ 'event': 'GAevent', 'eventCategory': 'contact-form', 'eventAction': 'successfully-sent', 'eventLabel': $('select[name="type_of_message"]').val() });
                } catch (e) {
                    conole.log(e);
                }

            } else if(response.data.length){
                $this_form.addClass("error");
                for (var dat in response.data) {
                    $this_form.find('.' + response.data[dat].class + '').addClass("error");
                }
            }
            else {
                $form_item.fadeOut(0);
                $error_message.fadeIn(0);
                $this_form.addClass("error");
                try {
                    dataLayer.push({ 'event': 'GAevent', 'eventCategory': 'contact-form', 'eventAction': 'error-sent', 'eventLabel': $('select[name="type_of_message"]').val() });
                } catch (e) {
                    conole.log(e);
                }
            }
        } catch (e) {
            console.log(e);
            console.log(response);
        } finally {
            $this_form.removeClass('loading');
        }
    });
})

